import { render, staticRenderFns } from "./addpaySdkConfig.vue?vue&type=template&id=6a25b021&"
import script from "./addpaySdkConfig.vue?vue&type=script&lang=js&"
export * from "./addpaySdkConfig.vue?vue&type=script&lang=js&"
import style0 from "./addpaySdkConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a25b021')) {
      api.createRecord('6a25b021', component.options)
    } else {
      api.reload('6a25b021', component.options)
    }
    module.hot.accept("./addpaySdkConfig.vue?vue&type=template&id=6a25b021&", function () {
      api.rerender('6a25b021', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aymentsdk/components/addpaySdkConfig.vue"
export default component.exports